import { useState, useEffect } from "react";
import "../../../entrydoor.css";
import "../finish/WinColor.css";
import { useInstallationData } from './useInstallationData';

const BrickmoldColor = ({
  controlId,
  value = {},
  onChange,
  label = "Brickmold Color",
  disabled = false,
  appliesTo = 'windows'
}) => {
  const [selectedColor, setSelectedColor] = useState(value);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { getBrickmoldColors, loading, error } = useInstallationData(appliesTo);

  const colors = getBrickmoldColors();

  useEffect(() => {
    setSelectedColor(value);
  }, [value?.value]);

  // Set default value when colors are loaded and no value is selected
  useEffect(() => {
    if (!loading && colors.length > 0 && !selectedColor?.value) {
      const defaultOption = colors[0];
      const newValue = { value: defaultOption.value, label: defaultOption.label };
      setSelectedColor(newValue);
      onChange(newValue);
    }
  }, [loading, colors]);

  const handleSelect = (option) => {
    const newValue = { value: option.value, label: option.label };
    setSelectedColor(newValue);
    onChange(newValue);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    if (!disabled) {
      setIsDropdownOpen(prev => !prev);
    }
  };

  const handleBlur = () => {
    setTimeout(() => setIsDropdownOpen(false), 100);
  };

  if (error) {
    console.error('Error loading brickmold colors:', error);
  }

  return (
    <div className="a-container">
      <label htmlFor="BrickmoldColor">{label}</label>
      <div
        className="custom-dropdown"
        style={{ zIndex: isDropdownOpen ? 1000 + controlId : 1 }}
      >
        <div
          className="dropdown-header"
          onClick={toggleDropdown}
          onBlur={handleBlur}
          style={{ cursor: disabled ? "default" : "pointer" }}
          tabIndex={disabled ? -1 : 0}
        >
          <div
            className="color-circle"
            style={{
              backgroundColor: selectedColor?.value || "transparent",
            }}
          />
          <span>{loading ? "Loading..." : (selectedColor?.label || "Select a color")}</span>
        </div>

        {isDropdownOpen && !loading && (
          <div className="dropdown-options">
            {colors.map((option, index) => (
              <div
                key={`${option.id}-${index}`}
                className="dropdown-option"
                onMouseDown={() => handleSelect(option)}
              >
                <div
                  className="color-circle"
                  style={{ backgroundColor: option.value }}
                />
                <span>{option.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BrickmoldColor;
